import React from "react";

function StatCard({ label, value }) {
  return (
    <div className="rounded-xl border border-white/10 bg-neutral-950/40 px-4 py-3 text-center">
      <div className="text-xs uppercase tracking-wide text-white/60">{label}</div>
      <div className="mt-1 text-2xl font-semibold">{value}</div>
    </div>
  );
}

export default function UserProfile({ profile, stats }) {
  if (!profile) return null;
  return (
    <section className="rounded-2xl border border-white/10 bg-neutral-950/50 p-4 text-sm">
      <h2 className="font-display text-xl font-semibold mb-3">Profile</h2>
      <div className="grid grid-cols-1 gap-3">
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Telegram ID:</div>
          <div className="italic text-white/90">{profile.telegramId}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Name</div>
          <div className="text-white/90">{profile.name || '—'}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Username</div>
          <div className="text-white/90">{profile.telegramUsername ? `@${profile.telegramUsername}` : '—'}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Phone</div>
          <div className="text-white/90">{profile.phoneNumber || '—'}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Email</div>
          <div className="text-white/90">{profile.email || '—'}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">License Plate</div>
          <div className="text-white/90">{profile.licensePlateNumber || '—'}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Vehicle Color</div>
          <div className="text-white/90">{profile.vehicleColour || '—'}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Vehicle Model</div>
          <div className="text-white/90">{profile.vehicleModel || '—'}</div>
        </div>
        <div className="grid grid-cols-[140px_1fr] items-start gap-2">
          <div className="text-white/70">Availability</div>
          <div className="text-white/90">
            {profile.availability ? (
              <>
                <div>Available</div>
                {profile.availableLocationName && (
                  <div className="text-white/70">{profile.availableLocationName}</div>
                )}
                {profile.myRadiusOfAvailabilityMiles ? (
                  <div className="text-white/70">Radius: {profile.myRadiusOfAvailabilityMiles} mi</div>
                ) : null}
                {profile.availableUntil ? (
                  <div className="text-white/70">Until: {new Date(profile.availableUntil).toLocaleString()}</div>
                ) : null}
              </>
            ) : (
              <div>Unavailable</div>
            )}
          </div>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-3 gap-2">
        <StatCard label="Total Rides" value={stats?.totalRides ?? 0} />
        <StatCard label="Completed" value={stats?.completedRides ?? 0} />
        <StatCard label="Success" value={`${stats?.successRate ?? 0}%`} />
      </div>
    </section>
  );
}
